import React, { Fragment } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { breadcrumbTitlesKey } from '../../../navigation';

import styles from './Breadcrumbs.module.scss';


export const Breadcrumbs = ({ className }) => {
  const [ t ] = useTranslation();
  const location = useLocation();
  const getPathArrayFromUrl = (url = location.pathname) =>
    url.replace(/^(\/)/, '').split('/').map(path => `/${path}`)
      .filter(item => !item.match(/^\/\d/));
  const getBreadcrumbPath = (array, i) => array.slice(0, i + 1).join('');
  const getBreadcrumbTitle = i => t(breadcrumbTitlesKey[getBreadcrumbPath(pathsArray, i)]);

  const pathsArray = getPathArrayFromUrl();

  return (
    <nav className={ classnames(styles.nav, className) }>
      <span className={ styles.links }>
        <Fragment key="root">
          <Link
            className={ styles.disabledLink }
            to={ getBreadcrumbPath(pathsArray, 0) }
          >
            {getBreadcrumbTitle(0)}
          </Link>
          {pathsArray.length - 1 !== 0 && <span className={ styles.separator }>/</span>}
        </Fragment>
        {pathsArray.map((path, i) => (
i
      ? (
        <Fragment key={ path }>
          <Link
            to={ `${getBreadcrumbPath(pathsArray, i)}${location.search || ''}` }
            className={ i === pathsArray.length - 1 ? styles.currentPath : styles.link }
          >
            { getBreadcrumbTitle(i)}
          </Link>
          {/* eslint-disable-next-line eqeqeq */}
          {i != pathsArray.length - 1 && <span className={ styles.separator }>/</span>}

        </Fragment>
        ) : ('')
))
      }
      </span>
    </nav>
  );
};
